module.exports = __webpack_public_path__ + "static/media/what-can-it-do-for-me.35b3e936.svg";